import Cookies from 'universal-cookie'
import axios from 'axios'
import config from '~/config'
import { getAccessToken } from '~/redux/helpers/user'

const cookies = new Cookies(window.document.cookie);

export const GetAllPromotions = () => async (dispatch) => {
	try {
		const accessToken = await getAccessToken();
		if (accessToken) {
			const response = await axios({
				url: `${config.base_url}/api/getAllPromotions`,
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'Authorization': `${accessToken}`,
				},
				data: JSON.stringify({
					"Pbu": cookies.get('portbu')
				})
			})
			const responseBody = response.data;
			if (!responseBody.error) {
				dispatch({
					type: 'FETCH_ALL_PROMOTIONS',
					payload: responseBody
				})
				return true;
			}
		}
	} catch (error) {
		dispatch({
			type: 'FAILED_ALL_PROMOTIONS',
			payload: error.message || "An error has occured."
		})
		return false
	}
}

export const ClearLeaderboardCache = () => (dispatch) => {
	dispatch({ type: 'CLEAR_LEADERBOARD_CACHE' })
}

export const GetLeaderboardData = ({ promoId, selectedTab = 0 }) => async (dispatch, getState) =>{
	try {
		const isFI = selectedTab === 0;
		const cacheKey = `${promoId}_${isFI ? 'FI' : 'PROMO'}`;
		const cache = getState().leaderboard.leaderboard.cache || {};
		const entry = cache[cacheKey];

		if (entry) {
			// Already fetched this tab in the current session — reuse it, no API call.
			dispatch({ type: 'USE_CACHED_LEADERBOARD_DATA', cacheKey })
			return true;
		}

		const accessToken = await getAccessToken();
		if (accessToken) {
			const response = await axios({
				url: `${config.base_url}/api/getLeaderboardData`,
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'Authorization': `${accessToken}`,
				},
				data: JSON.stringify({
					"Pbu": cookies.get('portbu'),
					"Oeid": cookies.get('oeid'),
					"PromoID": promoId,
					"IsFIRanking": isFI ? 1 : 0,
					"IsPromoRanking": isFI ? 0 : 1
				}),
			});
			const responseBody = response.data;
			if (!responseBody.error) {
				dispatch({
					type: 'FETCH_LEADERBOARD_DATA',
					payload: responseBody,
					cacheKey
				})
				return true;
			}
		}
	} catch (error) {
		dispatch({
			type: 'FAILED_LEADERBOARD_DATA',
			payload: error.message || "An error has occured."
		})
		return false
	}
}